
import { Spinner } from "@material-tailwind/react";
import CardTable from "../Table/CustomTable"
import { useState, useEffect } from "react";
import { faComputer } from "@fortawesome/free-solid-svg-icons";
import * as Papa from 'papaparse';
import { useTranslation } from "react-i18next";
import { BASE_NAME } from "../../routes";

export default function ResearchProjects() {
    const translationPrefix = 'Research';
    const { t } = useTranslation('global');
    const [proyectos, setProyectos] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const keys = [
        {
            id: 'nombre',
            label: t(`${translationPrefix}.name`)
        },
        {
            id: 'duracion',
            label: t(`${translationPrefix}.duration`),
        },
        {
            id: 'participantes',
            label: t(`${translationPrefix}.members`),
        },
        {
            id: 'financiado',
            label: t(`${translationPrefix}.financed`),
        },
        {
            id: 'descripcion',
            label: ''
        }
    ]

    const columns = [
        {
            id: 'nombre',
            label: t(`${translationPrefix}.name`),
        },
        {
            id: 'duracion',
            label: t(`${translationPrefix}.duration`),
        },
        {
            id: 'participantes',
            label: t(`${translationPrefix}.members`),
        },
        {
            id: 'financiado',
            label: t(`${translationPrefix}.financed`),
        },
        {
            id: 'more',
            label: ''
        }    
        
    ]

    useEffect(() => {
        fetch(`${BASE_NAME}/data/proyectos_investigacion.csv`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.text();
        })
        .then(data => {
            const parsedData = Papa.parse(data, { header: true,  delimiter: ';' }).data;
            setRowCount(parsedData.length);
            setProyectos(parsedData);
            setLoading(false);
        })
        .catch(error => console.error('Error fetching CSV data:', error));
    }, [])

    return (
        <>
        {
            loading ? 
            <div className="flex h-screen justify-center items-center">
                <Spinner className="h-12 w-12" />
            </div>
            :
            <section className="py-32">
                <div className="container mx-auto">
                    <div className="items-center justify-center flex">
                        <div className="w-full px-12 mb-12 px-4">
                            <CardTable 
                                title={t(`${translationPrefix}.research_projects`)}
                                icon={faComputer}
                                columns={columns} 
                                rows={proyectos}
                                keys={keys}
                                infoTitle={t(`${translationPrefix}.project_info`)}
                                rowCount={rowCount}
                            />
                        </div>
                    </div>
                </div>
            </section>
        }
        </>
    )
}